import React from 'react';

function Content() {
  return (
    <main className="content">
      <div className="card" id="services">
        <h2>Our Services</h2>
        <p>We offer a wide range of aviation services, including aircraft sales, leasing, and consulting, tailored to meet your needs.</p>
      </div>
      <div className="card" id="about">
        <h2>About Us</h2>
        <p>With decades of experience, heifersaero International is committed to providing top-tier solutions in the aviation industry.</p>
      </div>
      <div className="card">
        <h2>Contact Us</h2>
        <p>Reach out to our team today to discuss how we can assist with your aviation goals.</p>
      </div>
    </main>
  );
}

export default Content;